/* eslint-disable @typescript-eslint/naming-convention */
export class NICEDialerTimezoneSettings {
    timeZoneSettings: DialerTimeZoneSetting[];

    constructor(jsonObject?) {
        this.timeZoneSettings = jsonObject?.timeZoneSettings ;
    }
}

export class DialerTimeZoneSetting {
    StandardName: string;
    StartTime: string;
    EndTime: string;
    TimeZoneActiveToCall: boolean;
    OverrideTime: boolean;
    Active: boolean;

    constructor(jsonObject)
    {
        if (jsonObject) {
            this.StandardName = jsonObject?.standardName || jsonObject.StandardName;
            this.StartTime = jsonObject?.StartTime || '9:00';
            this.EndTime = jsonObject?.EndTime || '9:00';
            this.TimeZoneActiveToCall = jsonObject?.TimeZoneActiveToCall;
            this.OverrideTime = jsonObject?.OverrideTime;
            this.Active = jsonObject?.Active;
        }
    }
}
